var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.153362L17.5361 3.37221C16.5876 3.28968 15.8351 3.45474 15.2783 3.86742C14.7216 4.25946 14.3402 4.82688 14.134 5.5697C13.9485 6.29187 13.9175 7.11722 14.0412 8.04573H18V16H10.3608V7.73623C10.3608 5.03322 11 2.99049 12.2783 1.60803C13.5567 0.204946 15.4639 -0.279946 18 0.153362ZM7.63917 0.153362L7.17526 3.37221C6.2268 3.28968 5.47423 3.45474 4.91752 3.86742C4.36082 4.25946 3.97938 4.82688 3.7732 5.5697C3.58763 6.29187 3.5567 7.11722 3.68041 8.04573H7.63917V16H0V7.73623C0 5.03322 0.639175 2.99049 1.91753 1.60803C3.19588 0.204946 5.10309 -0.279946 7.63917 0.153362Z",
    fill: "#6841D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.f929e80fcc8e7703e194063c25f7e9dc.svg";
export { ForwardRef as ReactComponent };